'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Product = require('../../helpers/Product');

var _Router = require('../../helpers/Router');

var _LinkAccount = require('../../helpers/LinkAccount');

var _LoginOptions = require('./LoginOptions.scss');

var _LoginOptions2 = _interopRequireDefault(_LoginOptions);

var _mobile = require('../../../res/images/icon/mobile.svg');

var _mobile2 = _interopRequireDefault(_mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginOptions = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginOptions, _Component);

  function LoginOptions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LoginOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoginOptions.__proto__ || (0, _getPrototypeOf2.default)(LoginOptions)).call.apply(_ref, [this].concat(args))), _this), _this.loginEmail = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LoginEmail));
    }, _this.navSignUpOptions = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.SignUpOptions));
    }, _this.qrLogin = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.QRLogin));
    }, _this.hasQrFeature = function () {
      return _this.props.auth.productName === _Product.PRODUCT_NAMES.Music && !_this.isSmartSpeaker();
    }, _this.isSmartSpeaker = function () {
      return _this.props.auth.platform === _Product.PLATFORM_NAMES.SmartSpeaker;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LoginOptions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _LinkAccount.setProviderInStorageForLinkAccount)(this.props.auth);
      (0, _LinkAccount.setOldSessionIdInStorage)(this.props.auth.realm);
    }
  }, {
    key: 'render',
    value: function render() {
      var email = (0, _Product.getMailLogo)(this.props.auth.productName);
      var formatMessage = this.props.intl.formatMessage;

      var hasQrFeature = this.hasQrFeature();
      var isSmartSpeaker = this.isSmartSpeaker();
      var isButtonCenter = (0, _Product.isIconButtonCenter)(this.props.auth.productName);
      return _react2.default.createElement(
        'div',
        { className: _LoginOptions2.default.loginOptions },
        _react2.default.createElement(
          'div',
          { className: _LoginOptions2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.LoginTitle, {
            values: { product: formatMessage((0, _Product.getPlatformProductName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.platform, this.props.auth.clientId)) }
          }))
        ),
        _react2.default.createElement(_components.BaseButton, { className: _LoginOptions2.default.emailButton, onClick: this.loginEmail, buttonString: _DefaultString.translations.LoginWithEmail, icon: email, isCenter: isButtonCenter }),
        hasQrFeature ? _react2.default.createElement(_components.BaseButton, { className: _LoginOptions2.default.connectWithMobile, onClick: this.qrLogin, buttonString: _DefaultString.translations.ConnectWithMobile, icon: _mobile2.default, isCenter: isButtonCenter }) : null,
        _react2.default.createElement(_components.SocialLoginButtons, null),
        !isSmartSpeaker ? _react2.default.createElement(
          'div',
          { className: _LoginOptions2.default.newUser, onClick: this.navSignUpOptions },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.NewUser)
        ) : null,
        isSmartSpeaker ? _react2.default.createElement(
          'div',
          { className: _LoginOptions2.default.content },
          _react2.default.createElement(
            'div',
            { className: _LoginOptions2.default.speakerTitle },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.SmartSpeakerLoginSignUpFooterTitle)
          ),
          _react2.default.createElement(
            'div',
            { className: _LoginOptions2.default.speakerSubTitle },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.SmartSpeakerLoginSignUpFooter)
          ),
          _react2.default.createElement(_components.MobileAppButtons, { className: _LoginOptions2.default.mobileAppButtons })
        ) : null
      );
    }
  }]);
  return LoginOptions;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(LoginOptions);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginOptions/LoginOptions.js
// module id = 2011
// module chunks = 0